import { useEffect } from 'react';

export default function DealModal({ deal, type, onClose }) {
  const {
    name, brand, storage, image,
    package: pkg, data, minutes, onceOff, speed,
    price, wasPrice, save, term, prepaid,
    note, features,
  } = deal;

  const displayName = storage ? `${name} ${storage}` : name;

  // Close on Escape
  useEffect(() => {
    const handler = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', handler);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', handler);
      document.body.style.overflow = '';
    };
  }, [onClose]);

  const specs = [
    data     && { label: 'Data',     value: data },
    speed    && { label: 'Speed',    value: speed },
    minutes  && { label: 'Minutes',  value: minutes },
    onceOff  && { label: 'Once-off', value: onceOff },
    pkg      && { label: 'Package',  value: pkg },
  ].filter(Boolean);

  return (
    <div className="dm-backdrop" onClick={onClose} role="dialog" aria-modal="true">
      <div className="dm-panel" onClick={e => e.stopPropagation()}>

        {/* Close */}
        <button className="dm-close" onClick={onClose} aria-label="Close">✕</button>

        {/* Left — product */}
        <div className="dm-left">
          <div className="dm-img-wrap">
            {image
              ? <img src={image} alt={displayName} className="dm-img" />
              : <div className="dm-img-placeholder">No Image</div>
            }
          </div>
          <p className="dm-brand">{brand}</p>
          <h2 className="dm-name">{displayName}</h2>

          {specs.length > 0 && (
            <ul className="dm-specs">
              {specs.map(({ label, value }) => (
                <li key={label} className="dm-spec">
                  <span className="dm-spec__label">{label}</span>
                  <span className="dm-spec__value">{value}</span>
                </li>
              ))}
            </ul>
          )}

          {features && features.length > 0 && (
            <ul className="dm-features">
              {features.map((f, i) => <li key={i}>{f}</li>)}
            </ul>
          )}

          {note && <p className="dm-note">{note}</p>}
        </div>

        {/* Right — deal */}
        <div className="dm-right">
          <span className="dm-eyebrow">Vodacom Exclusive Deal</span>
          <h3 className="dm-right__name">{displayName}</h3>

          <div className="dm-divider" />

          {/* Pricing */}
          <div className="dm-pricing">
            {price != null ? (
              <>
                <div className="dm-price-main">
                  <span className="dm-price-currency">R</span>
                  <span className="dm-price-amount">{price.toLocaleString()}</span>
                  {term && <span className="dm-price-period">/pm</span>}
                </div>
                {term && (
                  <p className="dm-price-term">×{term} month contract</p>
                )}
                {wasPrice && (
                  <p className="dm-price-was">Was R{wasPrice.toLocaleString()}/pm</p>
                )}
                {save && (
                  <p className="dm-price-save">You save R{save.toLocaleString()}</p>
                )}
                {prepaid != null && (
                  <p className="dm-price-or">or <strong>R{prepaid.toLocaleString()}</strong> once-off</p>
                )}
              </>
            ) : prepaid != null ? (
              <>
                <div className="dm-price-main">
                  <span className="dm-price-currency">R</span>
                  <span className="dm-price-amount">{prepaid.toLocaleString()}</span>
                </div>
                <p className="dm-price-term">once-off payment</p>
              </>
            ) : (
              <div className="dm-price-main dm-price-enquire">Enquire</div>
            )}
          </div>

          <div className="dm-divider" />

          {/* What's included */}
          <div className="dm-includes">
            <p className="dm-includes__title">What's included</p>
            <ul className="dm-includes__list">
              <li>Vodacom SIM card</li>
              <li>24/7 network support</li>
              {data    && <li>{data} data per month</li>}
              {minutes && <li>{minutes} voice minutes</li>}
              {term    && <li>{term}-month contract flexibility</li>}
              {prepaid != null && <li>Once-off purchase option</li>}
            </ul>
          </div>

          <div className="dm-divider" />

          {/* Actions */}
          <div className="dm-actions">
            <button className="dm-btn dm-btn--primary">Apply Now</button>
            <button className="dm-btn dm-btn--secondary">Call Us</button>
          </div>

          <p className="dm-legal">
            Subject to credit approval. Terms &amp; conditions apply.
            All prices include VAT.
          </p>
        </div>
      </div>
    </div>
  );
}
